import React, {Key, useEffect, useState} from "react";
import {useMediaQuery} from "react-responsive";
import {Flex, Picker, Item, View, ProgressCircle, Button} from "@adobe/react-spectrum";
import Undo from "@spectrum-icons/workflow/Undo";
import Redo from "@spectrum-icons/workflow/Redo";
import Workspace from "../components/Workspace";
import Joystick from "../components/Joystick";
import TextContainer from "../components/TextContainer";
import SidePanel from "../components/SidePanel";
import Minimap from "../components/Minimap";
import AppHeader from "../components/AppHeader";
import SectionAbout from "../components/SectionAbout";
import SectionFeedback from "../components/SectionFeedback";
import IconLink from "../components/IconLink";
import {cleanName, getFontFromMap} from "../utils/fontUtils";
import externalLink from "../assets/images/external-link.svg";
import useAppStore from "../stores/useAppStore";
import useFontStore from "../stores/useFontStore";
import {PHONE_MAX_WIDTH, TABLET_MAX_WIDTH} from "../utils/constants";
import PhoneSectionHeader from "../components/PhoneSectionHeader";
import FlipButton from "../components/FlipButton";
import SectionTryThis from "../components/SectionTryThis";
import SectionFooter from "../components/SectionFooter";
import {useCounter} from "usehooks-ts";

function Home() {

    const isLoaded = useAppStore(state => state.isLoaded);
    const isRightHanded = useAppStore(state => state.isRightHanded);
    const isPortrait = useMediaQuery({query: "(orientation: portrait)"});
    const isTablet = useMediaQuery({minWidth: PHONE_MAX_WIDTH + 1, maxWidth: TABLET_MAX_WIDTH});
    const isPhone = useMediaQuery({maxWidth: PHONE_MAX_WIDTH});

    const currFont = useFontStore(state => state.currFont);
    const currFontStr = useFontStore(state => state.currFontStr);
    const fontHistory = useFontStore(state => state.fontHistory);
    const [historyIdx, setHistoryIdx] = useState(0);
    const { count, setCount, increment, decrement, reset } = useCounter(0);

    useEffect(() => {
        setCount(fontHistory.length-1);
    }, [fontHistory]);

    useEffect(() => {
        const font = fontHistory[count];
        //console.log('font', font)
        if (font !== undefined) {
            useFontStore.setState({
                currX: font.x,
                currY: font.y,
                currFont: font,
                currFontStr: cleanName(font._postscriptName)
            });
        }
    }, [historyIdx]);

    const onUndo = () => {
        //console.log('count', count);
        if(count > 0) {
            decrement();
            //console.log('--count', count);
            setHistoryIdx(count);
        }
    }
    const onRedo = () => {
        if(count < fontHistory.length) {
            increment();
            setHistoryIdx(count);
        }
    }


    return (
        <>
            {(!isTablet && isPhone) ?
                <AppHeader/>
                :
                <></>
            }

            <Flex direction={{
                base: (isPhone) ? "column" : "column",
                L: (!isPhone && isRightHanded) ? "row" : "row-reverse"
            }} height="100%">

                {isPhone ?
                    <PhoneSectionHeader/>
                    :
                    <SidePanel/>
                }

                <View flex={1}>
                    <Workspace>
                        <>
                            {!isLoaded ?
                                <div style={{
                                    position: "absolute",
                                    top: "50%",
                                    right: "50%",
                                    transform: "translate(50%, -50%)",
                                }}>
                                    <ProgressCircle aria-label="Loading…" size={"M"} isIndeterminate/>
                                </div>
                                :
                                <>
                                    <View
                                        paddingTop={(isPhone || isTablet) ? "size-300" : "size-700"}
                                        paddingEnd={(isPhone || isTablet) ? "size-300" : "size-700"}
                                        paddingStart={(isPhone || isTablet) ? "size-300" : "size-700"}
                                        paddingBottom={0}>
                                        <Flex direction={isPhone ? "column" : "row"}
                                              gap="size-200"
                                              alignItems="center"
                                              justifyContent="space-between">
                                            <IconLink
                                                fontSize={isPhone ? "12px" : "16px"}
                                                text={currFont._fontName}
                                                href={`https://fonts.adobe.com/fonts/${currFont._familyName.toLowerCase().replaceAll(" ", "-")}`}
                                                icon={<img src={externalLink} width={18} alt="external link"/>}/>
                                            <Flex
                                                gap="size-200"
                                                alignItems="center">
                                                <Button variant="primary"
                                                        onPress={onUndo}
                                                        isDisabled={count === 0}>
                                                    <Undo/>
                                                </Button>
                                                <Button variant="primary"
                                                        onPress={onRedo}
                                                        isDisabled={fontHistory.length === 0 || count >= fontHistory.length-1}>
                                                    <Redo/>
                                                </Button>
                                            </Flex>
                                        </Flex>
                                    </View>

                                    <TextContainer/>
                                </>
                            }

                            <div style={{
                                position: "absolute",
                                left: isPhone ? "32px" : "56px",
                                bottom: isPhone ? "12px" : "30px",
                                right: isPhone ? "32px" : "56px",
                                height: "140px",
                            }}>
                                <Flex
                                    alignItems="center"
                                    justifyContent="space-between"
                                    direction={isRightHanded ? "row" : "row-reverse"}
                                    isHidden={!isLoaded}>
                                    <Minimap/>
                                    <Joystick/>
                                </Flex>
                            </div>
                        </>
                    </Workspace>
                </View>
                {(isTablet && isPortrait) &&
                    <View paddingX="size-250" paddingBottom="size-250">
                        <FlipButton/>
                        <br/>
                        <SectionTryThis/>
                        <br/>
                        <br/>
                        <SectionFooter/>
                    </View>
                }

                {isPhone &&
                    <View paddingX="size-250" paddingBottom="size-250">
                        <FlipButton/>
                        <br/>
                        <hr/>
                        <br/>
                        <SectionAbout/>
                        <br/>
                        <br/>
                        <SectionTryThis/>
                        <br/>
                        <br/>
                        <SectionFeedback/>
                        <br/>
                        <br/>
                        <SectionFooter/>
                    </View>
                }
            </Flex>
        </>
    );
}

export default Home;